export default {
  "pages.layouts.userLayout.title": "輕量倉庫管理",
  "pages.login.pageTitle": "登入 / 註冊",
  "pages.login.success": "登入成功",
  "pages.login.failure": "登入失敗，請重試",
  "pages.login.email.placeholder": "電子郵件",
  "pages.login.email.required": "請輸入電子郵件",
  "pages.login.email.invalid": "請輸入有效的電子郵件地址",
  "pages.login.brandPitch": "為個人和小團隊打造的輕量出入庫 · 庫存 · 盤點工具",
  "pages.login.heroTitle": "用 AI 驅動庫存。\n思考、決策。",
  "pages.login.heroSubtitle":
    "在 LINE 上傳送「蘋果 入庫 20 個」即可。AI 告訴你補貨時機，月底自動產生經營報表。",
  "pages.login.slogan.1": "用 AI 驅動庫存。",
  "pages.login.slogan.2": "說一句話，記錄就留下。",
  "pages.login.slogan.3": "斷貨之前，AI 提醒你。",
  "pages.login.slogan.4": "月報也能自動產生。",
  "pages.login.line": "使用 LINE 繼續",
  "pages.login.google": "使用 Google 繼續",
  "pages.login.or": "或",
  "pages.login.socialComingSoon": "{provider} 登入即將開放",
  "pages.login.privacy":
    "繼續即表示同意我們的<terms>服務條款</terms>與<privacy>隱私政策</privacy>。",
  "pages.login.openMailbox.gmail": "開啟 Gmail ↗",
  "pages.login.openMailbox.yahooJp": "開啟 Yahoo!信箱 ↗",
  "pages.login.openMailbox.yahoo": "開啟 Yahoo Mail ↗",
  "pages.login.openMailbox.icloud": "開啟 iCloud 信箱 ↗",
  "pages.login.openMailbox.outlook": "開啟 Outlook ↗",
  "pages.login.code.send": "用電子郵件繼續",
  "pages.login.code.placeholder": "6 位驗證碼",
  "pages.login.code.required": "請輸入驗證碼",
  "pages.login.code.invalid": "請輸入 6 位數字",
  "pages.login.code.sent": "驗證碼已發送",
  "pages.login.code.sentTo": "請輸入發送到以下信箱的驗證碼：{email}",
  "pages.login.code.sendFailed": "驗證碼發送失敗",
  "pages.login.code.resendIn": "{seconds} 秒後可重新發送",
  "pages.login.code.resend": "重新發送驗證碼",
  "pages.login.continue": "繼續",
  "pages.login.changeEmail": "← 修改電子郵件",
  "pages.login.method.email": "電子郵件",
  "pages.login.method.password": "帳號・密碼",
  "pages.login.username.placeholder": "使用者名稱或電子郵件",
  "pages.login.username.required": "請輸入使用者名稱或電子郵件",
  "pages.login.password.placeholder": "密碼",
  "pages.login.password.required": "請輸入密碼",
  "pages.login.password.submit": "登入",
  "pages.404.subTitle": "抱歉，您造訪的頁面不存在",
  "pages.404.buttonText": "返回首頁",
  "pages.502.title": "無法連線到伺服器",
  "pages.502.subTitle": "伺服器暫時沒有回應，請稍後重試。",
  "pages.502.buttonText": "重新載入",
  "pages.oauth.title": "登入處理中",
  "pages.oauth.processing": "登入處理中…",
  "pages.oauth.success": "登入成功",
  "pages.oauth.fetchUserFailed": "取得使用者資訊失敗",
  "pages.oauth.backToLogin": "返回登入",
  "pages.oauth.error.stateMismatch": "認證資訊無效，請重試。",
  "pages.oauth.error.googleFailed": "Google 認證失敗，請重試。",
  "pages.oauth.error.disabled": "帳號已停用。",
  "pages.oauth.error.closing": "此帳號正在登出流程中，恢復請聯絡支援。",
  "pages.oauth.error.generic": "登入失敗，請稍後再試。",

  // 通用
  "common.action": "操作",
  "common.edit": "編輯",
  "common.delete": "刪除",
  "common.cancel": "取消",
  "common.confirm": "確認",
  "common.save": "儲存",
  "common.retry": "重試",
  "common.created": "建立成功",
  "common.updated": "更新成功",
  "common.deleted": "刪除成功",
  "common.createdAt": "建立時間",
  "common.reset": "重設",
  "common.export": "匯出",
  "common.exporting": "匯出中...",
  "common.export.success": "匯出成功",
  "common.export.noData": "沒有可匯出的資料",
  "common.import": "批次匯入",
  "common.upload": "點擊上傳",

  // 商品
  "product.title": "商品管理",
  "product.name": "商品名稱",
  "product.name.placeholder": "請輸入商品名稱",
  "product.name.required": "商品名稱為必填項",
  "product.sku": "SKU",
  "product.sku.placeholder": "請輸入 SKU 編碼（選填）",
  "product.tags": "標籤",
  "product.tags.placeholder": "輸入後按 Enter 新增標籤",
  "product.threshold": "低庫存閾值",
  "product.threshold.placeholder": "請輸入低庫存閾值",
  "product.threshold.invalid": "請輸入有效的閾值",
  "product.threshold.tooltip":
    "若商品包含規格，此值不參與狀態判定，僅作為新增規格時的預設閾值；規格的狀態以各自閾值為準。",
  "product.threshold.parentDefault": "預設 {value}",
  "product.status": "狀態",
  "product.status.active": "正常",
  "product.status.archived": "已封存",
  "product.create": "新增商品",
  "product.create.manual": "手動輸入",
  "product.edit": "編輯商品",
  "product.archive": "封存",
  "product.unarchive": "還原",
  "product.archived": "已封存",
  "product.unarchived": "已還原",
  "product.delete.confirm": "確定刪除該商品嗎？",
  "product.imageUrl": "商品圖片",
  "product.specSize": "規格尺寸",
  "product.specSize.placeholder": "例如: 58*36*16",
  "product.remark": "備註",
  "product.remark.placeholder": "請輸入備註（選填）",
  "product.contact": "往來單位",
  "product.contact.placeholder": "請選擇往來單位（選填）",
  "product.unit": "單位",
  "product.barcode": "條碼",
  "product.unitPrice": "單價",
  "product.unitPrice.placeholder": "請輸入單價（選填）",
  "product.detail": "商品詳情",
  "product.specDetail": "規格詳情",
  "product.notFound": "商品不存在",
  "product.recentTransactions": "最近出入庫記錄",
  "product.batchThreshold": "批次設定閾值",
  "product.batchThreshold.desc": "將為選取的 {count} 個商品設定低庫存閾值：",
  "product.image.hint": "最多上傳 3 張",
  "product.spec": "規格",
  "product.spec.add": "新增規格",
  "product.spec.name": "規格名稱",
  "product.spec.list": "規格列表",
  "product.spec.images": "規格圖片",
  "product.parentProduct": "所屬商品",
  "product.hasSpecs": "含規格",
  "product.noSpecs": "尚無規格",
  "product.specCount": "個規格",
  "product.specsColumn": "包含規格",
  "product.spec.select": "請選擇規格",
  "product.delete.hasChildren": "該商品包含規格，請先刪除所有規格",

  // 庫存
  "stock.title": "庫存查看",
  "stock.quantity": "庫存數量",
  "stock.status": "庫存狀態",
  "stock.status.normal": "正常",
  "stock.status.low": "低庫存",
  "stock.status.out": "缺貨",
  "stock.updatedAt": "最後更新",
  "stock.history.view": "變更歷史",
  "stock.history.title": "庫存變更歷史",
  "stock.history.type": "類型",
  "stock.history.quantity": "數量",
  "stock.history.type.inventoryCheck": "盤點調整",
  "stock.history.type.manual": "手動調整",
  "stock.history.total": "共 {total} 筆記錄",
  "stock.count": "盤點",
  "stock.count.start": "開始盤點",
  "stock.count.started": "盤點已開始",
  "stock.count.banner": "盤點中 · {date} · 已盤 {count} 件 · 差異 {variance} 項",
  "stock.count.status": "盤點狀態",
  "stock.count.uncounted": "未盤",
  "stock.count.counted": "實盤 {qty}",
  "stock.count.title": "盤點輸入",
  "stock.count.saved": "已儲存",
  "stock.count.noNext": "沒有更多未盤商品了",
  "stock.count.noSpecs": "該商品尚無規格，無法盤點",
  "stock.count.loadFailed": "盤點資料載入失敗",
  "stock.count.loadFailed.desc":
    "目前盤點狀態可能不正確，為避免覆蓋已輸入的實盤數，盤點功能已暫時停用。請點擊重試。",

  // 交易記錄（出入庫）
  "transaction.title": "出入庫",
  "transaction.operation": "出入庫操作",
  "transaction.tab.register": "入出庫登記",
  "transaction.tab.history": "入出庫歷史",
  "transaction.batch.title": "入出庫登記",
  "transaction.batch.items": "商品明細",
  "transaction.batch.addProduct": "新增商品",
  "transaction.batch.empty": "請至少新增一個商品並填寫數量",
  "transaction.batch.empty.hint": "尚未新增商品，點擊「新增商品」開始",
  "transaction.batch.duplicate": "該商品已在明細中",
  "transaction.batch.itemCount": "品目數",
  "transaction.batch.totalQty": "數量合計",
  "transaction.contact.placeholder": "請選擇往來單位（可選）",
  "transaction.history.bySlip": "依傳票",
  "transaction.history.byDetail": "依明細",
  "transaction.slip.void.confirm": "確認整筆作廢該傳票（含全部明細）？",
  "transaction.productInfo": "商品資訊",
  "transaction.type": "出入庫類型",
  "transaction.type.in": "入庫",
  "transaction.type.out": "出庫",
  "transaction.quantity": "數量",
  "transaction.quantity.required": "請輸入數量",
  "transaction.contact": "往來單位",
  "transaction.remark": "備註",
  "transaction.remark.placeholder": "請輸入（選填）",
  "transaction.status": "狀態",
  "transaction.normal": "正常",
  "transaction.voided": "已作廢",
  "transaction.void": "作廢",
  "transaction.void.confirm":
    "確定作廢該交易記錄嗎？作廢後將產生反向記錄恢復庫存。",
  "transaction.void.success": "已作廢",
  "transaction.in": "入庫",
  "transaction.out": "出庫",
  "transaction.in.submit": "確認入庫",
  "transaction.out.submit": "確認出庫",
  "transaction.in.success": "入庫成功",
  "transaction.out.success": "出庫成功",
  "transaction.product.required": "請選擇商品",
  "transaction.specList": "規格列表",
  "transaction.specName": "規格名稱",
  "transaction.productSpecName": "商品名稱 / 規格名稱",
  "transaction.specTag": "規格",
  "transaction.specInfo": "規格資訊",
  "transaction.currentStock": "目前庫存",
  "transaction.transactionQty": "出入庫數量",
  "transaction.referenceNo": "出入庫單號",
  "transaction.referenceNo.placeholder": "請輸入",
  "transaction.transactionDate": "出入庫日期",
  "transaction.remainingStock": "剩餘庫存",
  "transaction.unitPrice": "單價",
  "transaction.operator": "操作人",
  "transaction.history": "出入庫記錄",
  "transaction.selectProduct": "選擇商品",
  "transaction.select": "選擇",
  "transaction.addProduct": "新增商品",
  "transaction.searchProduct": "商品名稱",
  "transaction.submit": "送出",
  "transaction.clearCancel": "清空/取消",
  "transaction.selectProductHint": "請先選擇一個商品",
  "transaction.notSet": "未設定",
  "transaction.search.productName": "商品名稱",
  "transaction.search.dateRange": "操作時間",
  "transaction.search.stockRange": "庫存",
  "transaction.search.min": "庫存最小值",
  "transaction.search.max": "庫存最大值",

  // Dashboard
  "dashboard.title": "工作台",
  "dashboard.totalProducts": "商品總數",
  "dashboard.totalStock": "庫存總量",
  "dashboard.todayIn": "今日入庫",
  "dashboard.todayOut": "今日出庫",
  "dashboard.lowStockAlert": "低庫存預警",
  "dashboard.recentTransactions": "最近記錄",
  "dashboard.unit": "種",
  "dashboard.items": "件",
  "dashboard.vsYesterday": "較昨日",
  "dashboard.lowStockCount": "低庫存商品",
  "dashboard.outOfStockCount": "缺貨商品",
  "dashboard.txTrend": "出入庫趨勢",
  "dashboard.stockDistribution": "庫存狀態分佈",
  "dashboard.topProducts": "商品出入庫排行",
  "dashboard.7days": "近7天",
  "dashboard.14days": "近14天",
  "dashboard.30days": "近30天",
  "dashboard.viewAll": "查看全部",
  "dashboard.noLowStock": "尚無低庫存商品",
  "dashboard.outOfStockAlert": "需要處理",
  "dashboard.noOutOfStock": "無缺貨商品",
  "dashboard.subtitle": "一目了然檢視庫存狀況與待辦",
  "dashboard.kpi.title": "庫存概況",
  "dashboard.kpi.products": "商品數",
  "dashboard.kpi.outOfStock": "缺貨",
  "dashboard.kpi.lowStock": "低庫存",
  "dashboard.kpi.monthOutbound": "本月出庫件數",
  "dashboard.actions.title": "需要處理",
  "dashboard.actions.count": "{count} 件",
  "dashboard.actions.viewAll": "查看全部",
  "dashboard.actions.empty": "暫無需要處理的項目",
  "dashboard.actions.tag.check": "盤點",
  "dashboard.actions.checkOverdue.empty": "尚無盤點紀錄",
  "dashboard.actions.checkOverdue.days": "{days} 天未盤點",
  "dashboard.actions.tag.out": "缺貨",
  "dashboard.actions.tag.low": "少",
  "dashboard.actions.detail.remaining": "餘 {qty}",
  "dashboard.actions.detail.remainingThreshold": "餘 {qty} / 閾值 {threshold}",
  "dashboard.ai.bind.title": "連結 LINE 接收 AI 建議",
  "dashboard.ai.bind.desc": "在 LINE 輸入「蘋果 入庫 20個」即可。AI 每天早上自動推送補充建議。",
  "dashboard.ai.bind.cta": "立即連結",
  "dashboard.ai.recommend.title": "今日 AI 推薦",
  "dashboard.ai.recommend.count": "{count} 件",
  "dashboard.ai.recommend.viewAll": "查看全部",
  "dashboard.ai.urgency.high": "緊急",
  "dashboard.ai.urgency.medium": "注意",
  "dashboard.ai.urgency.low": "預防",
  "dashboard.ai.product.unknown": "（未指定商品）",
  "dashboard.ai.recommend.qtyHint": "件推薦 / 庫存 {stock}",

  // 聯絡人
  "contact.title": "往來單位",
  "contact.name": "名稱",
  "contact.name.required": "請輸入聯絡人名稱",
  "contact.type": "類型",
  "contact.type.placeholder": "輸入後按 Enter 新增類型標籤",
  "contact.type.tooltip": "可自由輸入，例如：供應商、客戶、物流公司等，用於分類往來單位。",
  "contact.remark": "備註",
  "contact.create": "新增聯絡人",
  "contact.edit": "編輯聯絡人",
  "contact.delete.confirm": "確定刪除該聯絡人嗎？",


  // 盤點
  "inventoryCheck.title": "盤點管理",
  "inventoryCheck.date": "盤點日期",
  "inventoryCheck.status": "狀態",
  "inventoryCheck.status.open": "進行中",
  "inventoryCheck.status.completed": "已完成",
  "inventoryCheck.status.voided": "已撤銷",
  "inventoryCheck.completedAt": "完成時間",
  "inventoryCheck.view": "查看",
  "inventoryCheck.detail": "盤點詳情",
  "inventoryCheck.items": "盤點項目",
  "inventoryCheck.bookQty": "帳面數量",
  "inventoryCheck.actualQty": "實際數量",
  "inventoryCheck.difference": "差異",
  "inventoryCheck.complete": "確認盤點",
  "inventoryCheck.complete.confirm": "確認完成盤點？完成後將產生庫存調整記錄。",
  "inventoryCheck.complete.noItems": "請先在庫存頁盤點商品",
  "inventoryCheck.completed": "盤點已完成",
  "inventoryCheck.void": "撤銷",
  "inventoryCheck.void.confirm": "確定撤銷該盤點嗎？",
  "inventoryCheck.voided": "盤點已撤銷",
  "inventoryCheck.notFound": "盤點單不存在",
  "inventoryCheck.inputActualQty": "輸入實際數量",
  "inventoryCheck.actualQty.empty": "未填",
  "inventoryCheck.actualQty.required": "請輸入實盤數，不可為空",
  "inventoryCheck.continueActive": "繼續進行中的盤點",
  "inventoryCheck.active.viewSheet": "查看盤點單",
  "inventoryCheck.active.completeNow": "完成盤點",
  "inventoryCheck.matchBook": "與帳面一致",
  "inventoryCheck.saveAndNext": "儲存並盤下一個",
  "inventoryCheck.removeItem": "撤銷本項",
  "inventoryCheck.removed": "已撤銷該商品的盤點",
  "inventoryCheck.progress": "已盤商品",
  "inventoryCheck.varianceCount": "差異項數",
  "inventoryCheck.varianceTotal": "差異合計",
  "inventoryCheck.variance.match": "一致",
  "inventoryCheck.drift.title": "部分商品的帳面數已變化",
  "inventoryCheck.drift.desc":
    "以下商品在盤點期間發生過出入庫，庫存已依盤點差異調整，請確認：",
  "inventoryCheck.currentQty": "目前庫存",
  "inventoryCheck.item.search": "搜尋商品 / SKU",
  "inventoryCheck.items.loadFailed": "盤點項載入失敗",
  "inventoryCheck.items.loadFailed.desc":
    "目前列表可能不完整。為避免誤撤銷一張有資料的盤點單，撤銷操作已暫時停用，請重試。",
  "inventoryCheck.item.delete": "刪除",
  "inventoryCheck.item.deleted": "已刪除盤點項目",
  "inventoryCheck.item.delete.confirm": "確定刪除該盤點項目嗎？",
  "inventoryCheck.goStockCount": "前往庫存頁盤點",
  "inventoryCheck.export": "匯出",
  "inventoryCheck.export.filename": "盤點表",
  "inventoryCheck.export.failed": "匯出失敗，請稍後重試",
  "inventoryCheck.itemCount": "已盤件數",
  "inventoryCheck.list.hint": "盤點從庫存頁發起，這裡是歷史台帳",
  "inventoryCheck.complete.result": "盤點已完成，共調整 {count} 個商品",

  // 設定
  "settings.tab.account": "帳號設定",
  "settings.tab.security": "安全設定",
  "settings.tab.business": "業務設定",
  "settings.tab.subscription": "訂閱資訊",
  "settings.account.info": "帳號資訊",
  "settings.account.username": "帳號",
  "settings.account.tenant": "租戶 ID",
  "settings.account.userCode": "用戶編號",
  "settings.account.createdAt": "註冊時間",
  "lang.ja-JP": "日語",
  "lang.en-US": "英語",
  "lang.zh-CN": "簡體中文",
  "lang.zh-TW": "繁體中文",
  "settings.account.displayName": "顯示名稱",
  "settings.account.displayNamePlaceholder": "請輸入顯示名稱",
  "settings.account.displayNameHint": "設定後，將代替帳號顯示",
  "settings.account.displayNameEdit": "變更",
  "settings.account.displayNameSuccess": "顯示名稱已更新",
  "settings.password.title": "修改密碼",
  "settings.password.changeDesc": "使用郵箱驗證碼即可修改為新密碼，無需填寫目前密碼。",
  "settings.password.old": "目前密碼",
  "settings.password.new": "新密碼",
  "settings.password.confirm": "確認新密碼",
  "settings.password.minLength": "密碼長度不能少於 6 位",
  "settings.password.mismatch": "兩次輸入的密碼不一致",
  "settings.password.submit": "修改密碼",
  "settings.password.success": "密碼修改成功",
  "settings.password.code": "驗證碼",
  "settings.password.codePlaceholder": "6 位數驗證碼",
  "settings.password.sendCode": "發送驗證碼",
  "settings.password.codeResendIn": "{seconds} 秒後重新發送",
  "settings.password.codeSent": "驗證碼已發送",
  "settings.password.codeSentTo": "驗證碼將發送至 {email}",
  "settings.password.codeInvalid": "請輸入 6 位數字",
  "settings.business.title": "業務設定",
  "settings.business.defaultThreshold": "預設低庫存閾值",
  "settings.business.defaultThreshold.tip": "新增商品時的預設低庫存閾值",
  "settings.business.save": "儲存設定",
  "settings.fieldVisibility.title": "欄位顯示",
  "settings.fieldVisibility.desc":
    "依需求開啟或關閉欄位，列表與表單將自動套用。關閉的欄位不會出現於輸入畫面，已存資料保留。",
  "settings.fieldVisibility.updated": "已更新",
  "settings.fieldVisibility.entity.product": "商品",
  "settings.fieldVisibility.field.product.sku": "SKU",
  "settings.fieldVisibility.field.product.specSize": "規格尺寸",
  "settings.fieldVisibility.field.product.contact": "往來單位",
  "settings.fieldVisibility.field.product.unit": "單位",
  "settings.fieldVisibility.field.product.barcode": "條碼",
  "settings.fieldVisibility.field.product.unitPrice": "單價",
  "settings.fieldVisibility.entity.transaction": "出入庫記錄",
  "settings.fieldVisibility.field.transaction.unitPrice": "出入庫單價",
  "settings.tab.app": "App設定",
  "settings.app.title": "App客製",
  "settings.app.icon": "App圖示",
  "settings.app.icon.desc":
    "上傳自訂圖示，用於行動應用顯示。建議使用 1024×1024 像素的 PNG 圖片。",
  "settings.app.icon.upload": "上傳圖示",
  "settings.app.icon.change": "更換圖示",
  "settings.app.icon.delete": "刪除圖示",
  "settings.app.icon.deleteConfirm": "確定刪除目前的圖示嗎？",
  "settings.app.icon.requirement": "PNG 格式，正方形，建議 1024×1024 px",
  "settings.app.icon.success": "圖示更新成功",
  "settings.app.icon.deleteSuccess": "圖示已刪除",
  "settings.app.icon.sizeError": "圖片尺寸需為正方形且不小於 512×512 像素",
  "settings.subscription.title": "目前訂閱",
  "settings.subscription.plan": "方案",
  "settings.subscription.maxProducts": "商品上限",
  "settings.subscription.maxTransactions": "月交易上限",
  "settings.subscription.perMonth": " 筆/月",

  // 意見回饋
  "feedback.title": "意見回饋",
  "feedback.submit": "送出回饋",
  "feedback.submit.success": "感謝您的回饋，我們會盡快處理",
  "feedback.category": "類別",
  "feedback.category.bug": "Bug",
  "feedback.category.suggestion": "建議",
  "feedback.category.feature": "功能需求",
  "feedback.category.dissatisfied": "不滿意",
  "feedback.content": "回饋內容",
  "feedback.content.placeholder": "請描述您遇到的問題或建議...",
  "feedback.content.required": "請輸入回饋內容",
  "feedback.screenshot": "截圖（選填）",
  "feedback.screenshot.add": "截圖",
  "feedback.screenshot.typeError": "只能上傳圖片檔案",
  "feedback.screenshot.sizeError": "圖片大小不能超過 2MB",
  "feedback.contactEmail": "聯絡信箱（選填）",
  "feedback.contactEmail.placeholder": "方便我們回覆您",
  "feedback.contactEmail.invalid": "請輸入有效的信箱地址",

  // NPS 問卷
  "nps.title": "您願意把這個產品推薦給朋友嗎？",
  "nps.subtitle": "0 = 完全不願意，10 = 非常願意",
  "nps.unlikely": "不太可能",
  "nps.likely": "非常可能",
  "nps.comment.placeholder": "有什麼想告訴我們的？（選填）",
  "nps.thanks": "感謝您的評價！",

  // 訂閱 & 升級
  "subscription.unlimited": "無限制",
  "subscription.upgrade.title": "升級到 Pro",
  "subscription.upgrade.desc": "解鎖全部功能，提升工作效率",
  "subscription.upgrade.button": "立即升級",
  "subscription.upgrade.success": "升級成功",
  "subscription.upgrade.feature.export": "支援匯出 Excel / CSV",
  "subscription.upgrade.feature.unlimited": "無限商品和交易記錄",
  "subscription.upgrade.feature.stats": "基礎統計與資料分析",

  // 定價頁
  "pricing.title": "選擇適合您的方案",
  "pricing.subtitle": "從免費方案開始，隨時升級解鎖更多功能",
  "pricing.monthly": "月繳",
  "pricing.annual": "年繳",
  "pricing.save": "省 {percent}%",
  "pricing.free": "免費",
  "pricing.freeDesc": "適合入門體驗基礎倉庫管理",
  "pricing.proDesc": "解鎖全部功能，無限制使用",
  "pricing.upgradeNow": "立即升級",
  "pricing.currentPlan": "目前方案",
  "pricing.currentPlanBtn": "目前方案",
  "pricing.downgrade": "降級",
  "pricing.recommended": "推薦",
  "pricing.perMonth": "月",
  "pricing.billedAnnually": "按年付費共 {amount}",
  "pricing.note": "所有方案均支援 14 天免費試用，無需綁定信用卡",
  "pricing.noPriceConfig": "目前無可用價格設定，請稍後再試",
  "pricing.checkoutFailed": "無法跳轉到付款頁面，請稍後再試",
  "pricing.unlimited": "無限制",
  "pricing.feature.products": "商品管理",
  "pricing.feature.transactions": "交易記錄",
  "pricing.feature.stockManagement": "庫存管理",
  "pricing.feature.inventoryCheck": "盤點功能",
  "pricing.feature.export": "匯出 Excel / CSV",
  "pricing.feature.statistics": "資料統計與分析",
  "pricing.feature.scan": "掃碼入庫",

  // 設定 - 訂閱管理
  "settings.subscription.status": "狀態",
  "settings.subscription.nextBilling": "下次扣款日",
  "settings.subscription.viewPlans": "查看方案",
  "settings.subscription.changePlan": "變更方案",
  "settings.subscription.manageBilling": "管理帳單",
  "settings.subscription.cancel": "取消訂閱",
  "settings.subscription.cancelConfirmTitle": "確認取消訂閱？",
  "settings.subscription.cancelConfirmDesc":
    "取消後目前帳期結束前仍可使用 Pro 功能，之後將降級為免費方案。",
  "settings.subscription.confirmCancel": "確認取消",
  "settings.subscription.cancelSuccess":
    "已取消訂閱，目前帳期結束後將降級為免費方案",
  "settings.subscription.portalFailed": "無法開啟帳單管理頁面，請稍後再試",
  "settings.subscription.gracePeriodWarning": "付款失敗",
  "settings.subscription.gracePeriodDesc":
    "您的訂閱付款未成功，請在 {date} 前更新付款方式，否則將自動降級為免費方案。",
  "settings.subscription.trialRemaining": "試用期剩餘 {days} 天",

  // ─── 智慧分析 ──────────────────────────────────────────────────
  "analytics.title": "智慧分析",
  "analytics.shipmentTrend": "出貨趨勢",
  "analytics.replenishment": "補貨建議",
  "analytics.productAnalysis": "商品分析",
  "analytics.movingAverage": "移動平均",
  "analytics.periodicity": "週期性偵測",
  "analytics.granularity.day": "按天",
  "analytics.granularity.week": "按週",
  "analytics.granularity.month": "按月",
  "analytics.timeRange": "時間範圍",
  "analytics.tags": "標籤篩選",
  "analytics.includeInbound": "顯示入庫",
  "analytics.outbound": "出庫",
  "analytics.inbound": "入庫",
  "analytics.last30days": "近30天",
  "analytics.last90days": "近90天",
  "analytics.custom": "自訂",
  "analytics.items": "件",
  "analytics.days": "天",
  "analytics.dailyOut": "日出庫量",
  "analytics.ma7": "7日均線",
  "analytics.ma14": "14日均線",
  "analytics.dow.1": "週一",
  "analytics.dow.2": "週二",
  "analytics.dow.3": "週三",
  "analytics.dow.4": "週四",
  "analytics.dow.5": "週五",
  "analytics.dow.6": "週六",
  "analytics.dow.7": "週日",
  "analytics.peakDay": "峰值日",
  "analytics.avgOut": "平均出庫量",
  "analytics.urgency": "緊急程度",
  "analytics.urgency.all": "全部",
  "analytics.urgency.immediate": "立即補貨",
  "analytics.urgency.today": "今天",
  "analytics.urgency.thisWeek": "本週內",
  "analytics.urgency.twoWeeks": "兩週內",
  "analytics.urgency.noAction": "無需補貨",
  "analytics.currentStock": "目前庫存",
  "analytics.dailyAvgOut": "日均出貨",
  "analytics.estimatedDaysLeft": "預計耗盡",
  "analytics.suggestedQuantity": "建議補貨量",
  "analytics.insufficientData": "資料累積中",
  "analytics.insufficientDataDesc":
    "需要更多出貨記錄才能產生分析，請繼續使用系統。",
  "analytics.insufficientDataCount": "{count} 個商品資料不足",
  "analytics.selectProduct": "選擇商品查看詳細分析",
  "analytics.viewAnalysis": "查看分析",
  "analytics.formulaNote": "計算說明",
  "analytics.perDay": "件/天",
  "analytics.aboutDays": "約 {days} 天",

  // --- 登出 ---
  "settings.account.logout": "登出",
  "settings.account.logoutDesc": "登出目前帳號，下次需重新登入。",
  "settings.account.logoutConfirmTitle": "確認登出？",

  // --- 註銷帳號 ---
  "settings.account.dangerZone": "危險操作",
  "settings.account.deleteAccount": "註銷帳號",
  "settings.account.deleteAccountDesc":
    "註銷後，帳號將在30天後被永久刪除。在此期間，您可以隨時透過登入恢復帳號。",
  "settings.account.deleteConfirmTitle": "確認註銷帳號？",
  "settings.account.deleteConfirmDesc":
    "請輸入密碼以確認註銷。註銷後您將被登出，30天內可透過登入恢復帳號。",
  "settings.account.deleteConfirmPassword": "請輸入密碼",
  "settings.account.deleteConfirmEmailDesc":
    "請輸入帳號信箱 {email} 以確認註銷。註銷後您將被登出，30天內可透過登入恢復帳號。",
  "settings.account.deleteConfirmEmailRequired": "請輸入帳號信箱",
  "settings.account.deleteConfirmEmailMismatch": "信箱與帳號不一致",
  "settings.account.deleteDataNotice": "30天後以下資料將被永久清空且無法恢復",
  "settings.account.deleteDataItem.records": "出入庫記錄",
  "settings.account.deleteDataItem.stock": "庫存記錄",
  "settings.account.deleteDataItem.products": "產品資訊",
  "settings.account.deleteDataItem.user": "使用者資訊",
  "settings.account.deleteSuccess": "帳號註銷請求已送出",

  // --- 帳號恢復 ---
  "accountClosing.title": "帳號註銷中",
  "accountClosing.desc":
    "您的帳號已申請註銷，還剩 {days} 天可恢復。逾期後所有資料將被永久刪除。",
  "accountClosing.restore": "恢復帳號",
  "accountClosing.restoreConfirmTitle": "確認恢復帳號？",
  "accountClosing.restoreConfirmPassword": "請輸入密碼確認恢復",
  "accountClosing.restoreConfirmEmail": "請輸入帳號信箱 {email} 確認恢復",
  "accountClosing.restoreSuccess": "帳號已恢復，歡迎回來",
  "accountClosing.logout": "登出",

  // 通知
  "notice.tab.system": "系統通知",
  "notice.tab.todo": "待辦提醒",
  "notice.empty": "尚無通知",
  "notice.todo.empty": "尚無待辦",
  "notice.readAll": "全部標為已讀",
  "notice.markSelectedRead": "標記已讀",
  "notice.selected": "已選 {count} 筆",
  "notice.viewAll": "查看全部",

  "notice.col.content": "訊息內容",
  "notice.col.time": "接收時間",
  "notice.col.type": "訊息類型",
  "notice.type.notice": "通知",
  "notice.type.announcement": "公告",
  "notice.detail.title": "訊息詳情",
  "notice.pagination.total": "共 {total} 筆",

  // 團隊邀請
  "invitation.inbox.title": "待處理邀請",
  "invitation.inbox.line": "{inviter} 邀請你加入「{team}」團隊",
  "invitation.inbox.expiresAt": "有效期至 {date}",
  "invitation.accept": "接受",
  "invitation.decline": "拒絕",
  "invitation.declineConfirm": "確定要拒絕此邀請嗎？",
  "invitation.acceptSuccess": "已加入「{team}」，可在右上角切換團隊",

  // 設定 - 通知訊息
  "settings.tab.notices": "通知訊息",
  "settings.notices.title": "通知訊息",

  // 設定 - 團隊管理
  "settings.tab.team": "團隊管理",
  "team.title": "團隊成員",
  "team.invite": "邀請成員",
  "team.invite.title": "邀請新成員",
  "team.invite.email": "電子郵件",
  "team.invite.emailInvalid": "請輸入正確的電子郵件",
  "team.invite.displayName": "顯示名（選填）",
  "team.invite.displayName.tip": "對方接受邀請後預設使用此名稱",
  "team.invite.message": "留言（選填）",
  "team.invite.checking": "正在檢查電子郵件…",
  "team.invite.alreadyMember": "該電子郵件已是本團隊成員",
  "team.invite.alreadyPending": "該電子郵件已有未處理的邀請，可點擊「重發」重新發送郵件",
  "team.invite.accountExists": "該電子郵件已註冊 Stockware，對方接受後將作為成員加入",
  "team.invite.accountNew": "對方將透過該電子郵件註冊並加入團隊",
  "team.invite.success": "邀請已發送",
  "team.invite.resend": "重發",
  "team.invite.resendSuccess": "邀請已重發",
  "team.invite.revoke": "撤銷",
  "team.invite.revokeConfirm": "確定撤銷此邀請嗎？",
  "team.invite.col.email": "電子郵件",
  "team.invite.col.expiresAt": "過期時間",
  "team.invite.col.createdAt": "邀請時間",
  "team.invitations.title": "待處理邀請",
  "teamSwitcher.title": "切換團隊",
  "teamSwitcher.switched": "已切換到「{team}」",
  "team.col.displayName": "暱稱",
  "team.col.username": "帳號",
  "team.col.role": "角色",
  "team.col.status": "狀態",
  "team.role.owner": "主帳號",
  "team.role.member": "成員",
  "team.status.active": "正常",
  "team.status.disabled": "已停用",
  "team.status.invited": "待邀請",
  "team.edit": "編輯",
  "team.edit.success": "成員資訊已更新",
  "team.remove": "移除",
  "team.remove.confirm": "確定移除該成員嗎？移除後該帳號將無法登入。",
  "team.disable": "停用",
  "team.enable": "啟用",
  "team.permissions": "權限設定",
  "team.permissions.title": "編輯權限 - {name}",
  "team.permissions.selectAll": "全選",
  "team.permissions.resetDefaults": "恢復預設",
  "team.permissions.resetDefaults.confirm": "確定恢復為預設權限嗎？",
  "team.permissions.save.success": "權限設定已儲存",
  "team.permissions.reset.success": "已恢復預設權限",
  "team.permissions.custom": "自訂",
  "team.permissions.default": "預設",
  "team.permissions.col.category": "分類",
  "team.permissions.col.target": "操作對象",
  "team.permissions.col.permissions": "功能權限",
  "team.permissions.module.warehouse": "倉儲管理",
  "team.permissions.module.smart_analytics": "智慧分析",
  "team.permissions.group.product": "商品管理",
  "team.permissions.group.stock": "庫存",
  "team.permissions.group.transaction": "出入庫",
  "team.permissions.group.inventory-check": "盤點",
  "team.permissions.group.contact": "往來單位",
  "team.permissions.group.expense": "支出",
  "team.permissions.group.income": "收入",
  "team.permissions.group.analytics": "資料分析",
  "team.permissions.action.list": "查看",
  "team.permissions.action.add": "新增",
  "team.permissions.action.edit": "編輯",
  "team.permissions.action.delete": "刪除",
  "team.permissions.action.void": "作廢",
  "team.permissions.action.export": "匯出",
  "team.permissions.action.view": "查看",
  "team.permissions.action.category": "分類管理",

  // 首次登入修改密碼
  "changeInitialPassword.title": "修改初始密碼",
  "changeInitialPassword.hint": "為了帳號安全，建議修改初始密碼",
  "changeInitialPassword.new": "新密碼",
  "changeInitialPassword.confirm": "確認新密碼",
  "changeInitialPassword.submit": "確認修改",
  "changeInitialPassword.skip": "跳過，稍後修改",
  "changeInitialPassword.success": "密碼修改成功",

  // 14 天試用邀請彈窗
  "trialOffer.title": "免費試用 Pro 14 天",
  "trialOffer.subtitle": "無需綁卡，體驗全部 Pro 功能",
  "trialOffer.body": "您當前是免費版用戶，試用期間可解鎖全部功能，14 天後自動恢復為免費版。僅限一次。",
  "trialOffer.accept": "立即開啟試用",
  "trialOffer.decline": "暫不試用",
  "trialOffer.successMessage": "試用已開啟，祝您使用愉快",
  "trialOffer.failedMessage": "開啟試用失敗，請稍後重試",

  // 公開支援頁（/support），作為 App Store「支援網址」提交
  "pages.support.pageTitle": "支援中心",
  "pages.support.lead":
    "這裡是庫存管理應用 Stockware 的使用者支援頁。請先查看下方常見問題；若仍未解決，歡迎隨時與我們聯繫。",
  "pages.support.contact.heading": "聯繫我們",
  "pages.support.contact.intro":
    "使用過程中遇到問題，或有功能建議，請透過以下信箱聯繫我們。同時告知您使用的裝置（iPhone / Android / 瀏覽器）、應用版本以及具體情況，可以讓我們更快為您處理。",
  "pages.support.contact.operatorLabel": "營運主體",
  "pages.support.contact.emailLabel": "信箱",
  "pages.support.contact.hoursLabel": "受理時間",
  "pages.support.contact.hoursValue": "工作日 10:00–18:00（日本時間，節假日除外）",
  "pages.support.contact.replyLabel": "回覆時間",
  "pages.support.contact.replyValue": "2–3 個工作日內",
  "pages.support.faq.heading": "常見問題",
  "pages.support.faq.q1": "無法登入，收不到驗證碼郵件。",
  "pages.support.faq.a1":
    "Stockware 支援信箱 6 位驗證碼、密碼以及 Google 帳號三種登入方式。如果收不到驗證碼，請先檢查垃圾郵件匣，並在 60 秒後點擊「重新發送驗證碼」。若仍未收到，請聯繫我們。",
  "pages.support.faq.q2": "忘記密碼了。",
  "pages.support.faq.a2":
    "在登入頁選擇「使用信箱驗證碼登入」即可免密碼登入。登入後進入應用的「我的 → 設定 → 修改密碼」，透過信箱驗證碼設定新密碼，無需輸入原密碼。",
  "pages.support.faq.q3": "庫存數量與實際對不上。",
  "pages.support.faq.a3":
    "請使用盤點功能。在庫存頁發起盤點，輸入實際清點的數量，系統會自動計算與帳面數的差異；確認後自動產生庫存調整記錄。若盤點期間該商品發生了出入庫，確認時會提示您。",
  "pages.support.faq.q4": "想刪除誤建的商品。",
  "pages.support.faq.a4":
    "可在商品列表或商品詳情中「封存」，封存後不再出現在一般列表中，出入庫記錄仍會保留。如需徹底移除請使用「刪除」。刪除無法復原，已有出入庫記錄的商品建議封存。",
  "pages.support.faq.q5": "可以和員工或家人一起使用嗎？",
  "pages.support.faq.a5":
    "可以。在「我的 → 團隊管理」中透過信箱邀請成員，可為每位成員單獨設定角色（擁有者 / 成員）與權限，也可停用或移除。若同時屬於多個團隊，可在應用內切換。",
  "pages.support.faq.q6": "想註銷帳號。",
  "pages.support.faq.a6":
    "可在應用的「我的 → 設定 → 註銷帳號」中申請。提交後 30 天內登入即可恢復帳號；超過 30 天後，出入庫記錄、庫存記錄、商品記錄和使用者資訊將被徹底刪除且無法恢復。",
  "pages.support.links.heading": "相關連結",
  "pages.support.links.site": "官方網站",
  "pages.support.links.terms": "使用者條款",
  "pages.support.links.privacy": "隱私政策",
};
